import React, { useContext, useEffect, useState } from "react"

export interface TourContextType {
    runTour: boolean
    // startTutorial: () => void
    stopTutorial: () => void
    setTutorialSection: (section: tutorialSectionType) => void
    tutorialSection: tutorialSectionType
    firstTutorialCompleted: boolean
    completeFirstTutorial: () => void;

}
export type tutorialSectionType = "dashboardChips" | "actionsNeeded" | "studentTable" | "userMenu" | "mainMenu" | "reportsMain" | "reportTableToolBar" | "studentInsightsMain" | null
export const TourContext = React.createContext<TourContextType>({
    runTour: false,
    // startTutorial: () => { return },
    stopTutorial: () => { return },
    setTutorialSection: (section: tutorialSectionType) => { return },
    tutorialSection: null,
    firstTutorialCompleted: false,
    completeFirstTutorial: () => { return }

});

TourContext.displayName = "TourContext";

export interface TourContextProviderProps {
    children: React.ReactNode
}
export const useTourContext = () => useContext(TourContext);
export const TourProvider = ({ children }: TourContextProviderProps) => {
    const [tutorialSection, setTutorialSection] = useState<tutorialSectionType>(null);
    const runTour = tutorialSection !== null;
    const [firstTutorialCompleted, setFirstTutorialCompleted] = useState(
        () => sessionStorage.getItem("firstTutorialCompleted") === "true"
    );

    const completeFirstTutorial = () => {
        sessionStorage.setItem("firstTutorialCompleted", "true");
        setFirstTutorialCompleted(true);
    };
    // const startTutorial = () => {
    //     setRunTour(true)
    // };
    const stopTutorial = () => {
        setTutorialSection(null);
    }
    const handleSetTutorialSection = (input: tutorialSectionType) => {
        setTutorialSection(input)
    }

    return (
        <TourContext.Provider value={{
            runTour, stopTutorial,
            firstTutorialCompleted, completeFirstTutorial,
            tutorialSection, setTutorialSection: handleSetTutorialSection
        }}>
            {children}
        </TourContext.Provider>
    )
}